import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import StoredLayout from 'layouts/StoredLayout';

import LoadingSpinner from 'cyder/loadingSpinner/LoadingSpinner';
import AnalyticsCard from 'pages/analytics/components/AnalyticsCard';
import { membershipRenewalSuccessAnalytics } from 'actions/analytics/memberAnalyticsAction';

class BreakdownOfSuccessfulRenewal extends React.Component {
    constructor(props) {
        super(props);
        this.load = this.load.bind(this);
        this.state = {
            refreshState: new Date().getTime(),
        };
    }
    componentDidMount() {
        this.load();
    }
    componentDidUpdate() {
        if (this.state.refreshState != this.props.membership.refresh) {
            this.load();
            this.setState({
                refreshState: this.props.membership.refresh,
            });
        }
    }
    load() {
        this.props.load().then(res => {
            let total = 0;
            res.data.forEach(item => {
                total += item.count;
            });
            this.setState({
                data: res.data,
                total,
            });
        });
    }
    render() {
        return (
            <AnalyticsCard
                title={`${
                    this.state.data != null
                        ? `Memberships Expiring/Expired within ${moment(this.props.membership.startDate, 'DD/MM/YYYY').format(
                              'DD MMMM YYYY',
                          )} - ${moment(this.props.membership.endDate, 'DD/MM/YYYY').format('DD MMMM YYYY')}`
                        : `...`
                }`}
            >
                {this.state.data == null ? (
                    <LoadingSpinner />
                ) : (
                    <React.Fragment>
                        <h2 style={{ color: '#78BE20' }}>Renewal Analytics</h2>
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th />
                                        <th>Quantity</th>
                                        <th>Percentage</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.data.map((item, i) => {
                                        return (
                                            <tr key={i}>
                                                <td style={{ width: '60%' }}>{item.packageName}</td>
                                                <td style={{ width: '20%' }}>{item.count}</td>
                                                <td style={{ width: '20%' }}>{Math.round((item.count * 100) / this.state.total)}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </React.Fragment>
                )}
            </AnalyticsCard>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
        membership: state.membershipRenewalAnalyticsReducer,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        load: () => {
            return dispatch(membershipRenewalSuccessAnalytics());
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(StoredLayout(BreakdownOfSuccessfulRenewal));
